<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			船舶船型
		</div>

		<div @click="isShow = !isShow"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加船舶船型
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in tkgla">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}} <span
								style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao"
								style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div" :to="{ path:'/chtkdetail',query:{id:item.id,title:item.title} }"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="isShow">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<!-- <el-upload
					  action="https://admin.shipoe360.com/api/picture/upload_img_picture"
					  multiple
					  list-type="picture-card"
					  :on-preview="handlePreview"
					  :on-success="handsuccessss"
					  :file-list="fileListss"
					  :on-remove="handleRemove">
					  <i class="el-icon-plus"></i>
					</el-upload> -->
				</div>

				<div style="width: 100%;height: 50px;margin-top: 100px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						视频:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_video" :on-preview="handlePreviews"
						:on-remove="handleRemoves" :before-remove="beforeRemoves" :on-success="handsuccesssss"
						:limit="1" :on-exceed="handleExceeds" :file-list="fileListsss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>


				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						设计单位:
					</div>
					<el-input v-model="form.design_unit" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						建造单位:
					</div>
					<el-input v-model="form.construction_unit" style="float: left;width: 70%;margin-top: 5px;">
					</el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						建造时间:
					</div>
					<el-date-picker style="margin-top: 5px;" value-format="yyyy-MM-dd"
						v-model="form.zj_time" type="date" placeholder="选择日期">
					</el-date-picker>
					<!-- <el-input v-model="form.zj_time " style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						交付时间:
					</div>
					<el-date-picker style="margin-top: 5px;" value-format="yyyy-MM-dd"
						v-model="form.jf_time" type="date" placeholder="选择日期">
					</el-date-picker>
					<!-- <el-input v-model="form.jf_time " style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						造价:
					</div>
					<el-input v-model="form.price " style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						船舶业主:
					</div>
					<el-input v-model="form.ship_owner" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						IMO/编号:
					</div>
					<el-input v-model="form.imo" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						长度:
					</div>
					<el-input v-model="form.length" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						宽度:
					</div>
					<el-input v-model="form.width" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						总吨:
					</div>
					<el-input v-model="form.all_weight" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						净吨:
					</div>
					<el-input v-model="form.sell_weight" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						基础信息:
					</div>
					<el-input v-model="form.basic_information" style="float: left;width: 70%;margin-top: 5px;">
					</el-input>
				</div> -->
				<div style="width: 100%;height: 550px;margin-top: 20px;">
					<div
						style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						基础信息 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.basic_information" :setting="setting" />
					</div>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						vr地址:
					</div>
					<el-input v-model="form.vr_link" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						载重吨:
					</div>
					<el-input v-model="form.zz_weight" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						吃水:
					</div>
					<el-input v-model="form.water" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						航速/节:
					</div>
					<el-input v-model="form.hs" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						船型:
					</div>
					<el-cascader  :placeholder="communityName" class="eloptionxg" :options="industry" @change="handleAreaChange" ref="cascade">
					</el-cascader>
					<div style="font-size: 12px;color: orangered;padding-left: 50px;" @click="gotocxa">没有所需船型？点击这里申请
					</div>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;margin-top: 20px;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
		<div style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5);z-index: 999;"
			v-show="qbesd">

			<el-form ref="form" :model="form" label-width="80px"
				style="width: 50%;height: 250px;margin: 0 auto;background: #FFF;margin-top: 200px;">
				<div @click="qbesaaa"
					style="width: 95%;height: 50px;font-size: 20px;text-align: right;padding-right: 20px;line-height: 50px;">
					X</div>
				<el-form-item label="类别名称">
					<el-input v-model="qbesds.name"></el-input>
				</el-form-item>
				<el-form-item label="船型名称">
					<el-input v-model="qbesds.names"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmits">立即申请</el-button>
					<el-button @click="qbesd = false">取消</el-button>
				</el-form-item>
			</el-form>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import datas from "./data.js";

	export default {
		data() {
			return {
				isShow: false,
				tkgla: '',
				industry: [],
				communityName:'',
				qbesds: {
					name: '',
					names: ''
				},
				form: {
					title: '',
					picture: '',
					zhiwei: '',
					chanpin: '',
					area: '',
					money: '',
					dianzai: '',
					zip: '',
					content: '',
					type: '',
					design_unit: '',
					construction_unit: '',
					ship_owner: '',
					basic_information: '',
					vr_link: '',
					zj_time: '',
					jf_time: '',
					price: '',
					imo: '',
					length: '',
					width: '',
					all_weight: '',
					sell_weight: '',
					zz_weight: '',
					water: '',
					cx_type: '',
					hs: '',
					video: '',

				},
				qbesd: false,
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				fileListss: [],
				fileListsss: [],
				fileLists: [],
				xsa: false,
				qid: '',
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media paste table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					paste_data_images: false,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
				
				},
			}
		},
		mounted() {
			this.gotosb()
			console.log(datas)
			this.industry = datas
		},
		methods: {
			async onSubmits() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				console.log('1')
				let res = await http.post('api/picture/cxsq', {
					type_one: this.qbesds.name,
					type_two: this.qbesds.names,
					status: '1', //1申请中，2审核通过，3审核未通过
					uid: loginInfo.id
				})
				console.log(res)
				if (res.data.code == 200) {
					this.qbesd = false
					this.qbesds.name = ''
					this.qbesds.names = ''
					this.$notify({
						title: '成功',
						message: '申请成功',
						type: 'success'
					});
				}
			},
			qbesaaa() {
				this.qbesd = false
			},
			gotocxa() {
				console.log('1')
				this.qbesd = true
			},
			handlePreview(file) {
				console.log(file);
			},
			handlePreviews(file) {
				console.log(file);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleExceeds(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleRemoves(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeRemoves(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccesss(response, file, fileList) {
				this.form.picture = response.data.path
			},
			handsuccessss(response, file, fileList) {
				console.log(response)
				this.form.picture = response.data.path
				// this.form.picture = response.data.img.url
			},
			handsuccesssss(response, file, fileList) {
				this.form.video = response.data.path
			},
			async handleAreaChange(val) {
				console.log(val)
				this.industry.forEach(item => {
					if (item.value == val[0]) {
						item.children.forEach(resb => {
							if (resb.value == val[1]) {
								this.form.cx_type = resb.label
							}
						})
					}
				})
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'tuku',
					type: 'content',
					mid: '5',
					uid: loginInfo.id,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}
				this.gotosb()
			},
			xiugaia(val) {
				console.log(val)
				this.xsa = true
				this.isShow = true

				this.qid = val.id
				this.form.title = val.title
				this.form.picture = val.picture
				this.form.design_unit = val.design_unit
				this.form.cx_type = val.cx_type
				this.communityName = val.cx_type
				this.form.construction_unit = val.construction_unit
				this.form.ship_owner = val.ship_owner
				this.form.basic_information = decodeURIComponent(val.content)
				this.form.vr_link = val.vr_link
				this.form.zj_time = val.zj_time
				this.form.jf_time = val.jf_time
				this.form.price = val.price
				this.form.imo = val.imo
				this.form.length = val.length
				this.form.width = val.width
				this.form.all_weight = val.all_weight
				this.form.sell_weight = val.sell_weight
				this.form.zz_weight = val.zz_weight
				this.form.water = val.water
				this.form.hs = val.hs
				this.form.video = val.video

				if (this.form.picture === 'http://admin.shipoe360.com/public/') {
					this.form.picture = ''
				} else {
					this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/', 'g'),
						'')
				}

				if (this.form.video === 'http://admin.shipoe360.com/public/') {
					this.form.video = ''
				} else {
					this.form.video = this.form.video.replace(new RegExp('http://admin.shipoe360.com/public/', 'g'), '')
				}


				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "图片";
				fileObjss.url = val.picture;
				fileArrss.push(fileObjss);
				// this.fileListss = this.form.picture ? JSON.parse(this.form.picture):[]
				this.fileListss = fileArrss

				let fileArrs = [];
				let fileObjs = {};
				fileObjs.name = "视频";
				fileObjs.url = val.video;
				fileArrs.push(fileObjs);
				this.fileLists = fileArrs
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/person_page_historical_ship', {
					uid: loginInfo.id,
					page: val
				})
				console.log(res)
				this.tkgla = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit

			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'tuku',
					type: 'content',
					mid: '5',
					uid: loginInfo.id
				})
				this.tkgla = res.data.data.list.data
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'tuku',
						type: 'content',
						mid: '5',
						title: this.form.title,
						// picture: JSON.stringify(this.form.picture),
						picture: this.form.picture,
						design_unit: this.form.design_unit,
						cx_type: this.form.cx_type,
						construction_unit: this.form.construction_unit,
						ship_owner: this.form.ship_owner,
						content: encodeURIComponent(this.form.basic_information),
						vr_link: this.form.vr_link,
						zj_time: this.form.zj_time,
						jf_time: this.form.jf_time,
						price: this.form.price,
						imo: this.form.imo,
						length: this.form.length,
						width: this.form.width,
						all_weight: this.form.all_weight,
						sell_weight: this.form.sell_weight,
						zz_weight: this.form.zz_weight,
						water: this.form.water,
						hs: this.form.hs,
						video: this.form.video,
						id: this.qid,
						uid: loginInfo.id
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileLists = []
						this.fileListss = []
						this.form.title = ''
						this.form.picture = ''
						this.form.zhiwei = ''
						this.form.chanpin = ''
						this.form.area = ''
						this.form.money = ''
						this.form.dianzai = ''
						this.form.zip = ''
						this.form.content = ''
						this.form.hs = ''
						this.form.water = ''
						this.form.zz_weight = ''
						this.form.vr_link = ''
						this.form.basic_information = ''
						this.form.sell_weight = ''
						this.form.all_weight = ''
						this.form.width = ''
						this.form.length = ''
						this.form.imo = ''
						this.form.ship_owner = ''
						this.form.price = ''
						this.form.jf_time = ''
						this.form.zj_time = ''
						this.form.construction_unit = ''
						this.form.design_unit = ''
						this.communityName = ''
						this.$refs['cascade'].panel.clearCheckedNodes()
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/common/add', {
						model: 'tuku',
						type: 'content',
						mid: '5',
						title: this.form.title,
						// picture: JSON.stringify(this.form.picture),
						picture: this.form.picture,
						design_unit: this.form.design_unit,
						cx_type: this.form.cx_type,
						construction_unit: this.form.construction_unit,
						ship_owner: this.form.ship_owner,
						content: decodeURIComponent(this.form.basic_information),
						vr_link: this.form.vr_link,
						zj_time: this.form.zj_time,
						jf_time: this.form.jf_time,
						price: this.form.price,
						imo: this.form.imo,
						length: this.form.length,
						width: this.form.width,
						all_weight: this.form.all_weight,
						sell_weight: this.form.sell_weight,
						zz_weight: this.form.zz_weight,
						water: this.form.water,
						hs: this.form.hs,
						video: this.form.video,
						// zhiwei: this.form.zhiwei,
						// chanpin: this.form.chanpin,
						// area: this.form.area,
						// money: this.form.money,
						// zip: this.form.zip,
						// dianzai: this.form.dianzai,
						// content: this.form.content,
						uid: loginInfo.id
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileLists = []
						this.fileListss = []
						this.form.title = ''
						this.form.picture = ''
						this.form.zhiwei = ''
						this.form.chanpin = ''
						this.form.area = ''
						this.form.money = ''
						this.form.dianzai = ''
						this.form.zip = ''
						this.form.content = ''
						this.form.hs = ''
						this.form.water = ''
						this.form.zz_weight = ''
						this.form.vr_link = ''
						this.form.basic_information = ''
						this.form.sell_weight = ''
						this.form.all_weight = ''
						this.form.width = ''
						this.form.length = ''
						this.form.imo = ''
						this.form.ship_owner = ''
						this.form.price = ''
						this.form.jf_time = ''
						this.form.zj_time = ''
						this.form.construction_unit = ''
						this.form.design_unit = ''
						this.form.cx_type = ''
						this.$refs['cascade'].panel.clearCheckedNodes()
					}
				}
			}
		}
	}
</script>

<style>
	::-webkit-input-placeholder { /* WebKit browsers */ 
	color: #000; 
	} 
	:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
	color: #000; 
	} 
	::-moz-placeholder { /* Mozilla Firefox 19+ */ 
	color: #000; 
	} 
	:-ms-input-placeholder { /* Internet Explorer 10+ */ 
	color: #000; 
	} 
	
	input::-webkit-input-placeholder {
	  -webkit-text-fill-color: #000;
	
	}
</style>
